import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePage } from "@/lib/content";
import { Reveal } from "@/components/site/Motion";
import { PageHero, CTABand, usePageTitle } from "@/components/site/Bits";

export default function Palestras() {
  usePageTitle("Palestras e Treinamentos");
  const { sections: s } = usePage("palestras");
  const items = Array.isArray(s.items) ? s.items : [];

  return (
    <>
      <PageHero title={s.hero_title || "Palestras e Treinamentos"} text={s.hero_text} overline="Silva Cotan e Associados — Assessoria Jurídica" />

      <section className="bg-ivory">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
          <Reveal>
            <p className="max-w-2xl text-base leading-relaxed text-inkgray md:text-lg">{s.intro_text}</p>
          </Reveal>
          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {items.map((item, i) => (
              <Reveal key={i} delay={0.05 * (i % 3)}>
                <div className="h-full border border-navy/10 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-gold" data-testid={`palestra-card-${i}`}>
                  <span className="font-display text-sm italic text-gold">0{i + 1}</span>
                  <h2 className="mt-3 font-display text-xl text-navy md:text-2xl">{item.title}</h2>
                  <p className="mt-3 text-sm leading-relaxed text-inkgray">{item.text}</p>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.2}>
              <Link
                to="/contato"
                data-testid="palestras-cta-card"
                className="group flex h-full min-h-[170px] flex-col justify-between bg-navy p-8 text-ivory transition-colors hover:bg-navy-2"
              >
                <p className="font-display text-xl md:text-2xl">Solicite uma palestra ou treinamento</p>
                <span className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-gold">
                  Entrar em contato
                  <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </Link>
            </Reveal>
          </div>
        </div>
      </section>

      <CTABand title="Capacite sua equipe com conteúdo jurídico aplicável." button="Fale conosco" />
    </>
  );
}
